import CardPage from './CardPage';

export default CardPage;
export * from './types';
export { CardPage };
